import { render, staticRenderFns } from "./Exnews-add.vue?vue&type=template&id=3e95b92d&scoped=true&"
import script from "./Exnews-add.vue?vue&type=script&lang=js&"
export * from "./Exnews-add.vue?vue&type=script&lang=js&"
import style0 from "./Exnews-add.vue?vue&type=style&index=0&id=3e95b92d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e95b92d",
  null
  
)

export default component.exports